var urlApi = 'https://csmik.pl/api/'
var urlImages = 'https://csmik.pl/wp-content/themes/mik/'


export { urlApi, urlImages }